import React, { useState, useCallback } from 'react';
import { useParams, Link } from 'react-router-dom';
import PhotoGallery from "react-photo-gallery";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import './EventDetail.css';

const EventDetail = () => {
  const { eventId } = useParams();
  const [lightboxIndex, setLightboxIndex] = useState(-1);

  const generateEventPhotos = (eventId) => {
    if (eventId === '2') {
      const event2Photos = [
        'EZ8A5575.JPG', 'EZ8A5579.JPG', 'EZ8A5583.JPG', 'EZ8A5586.JPG', 'EZ8A5587.JPG',
        'EZ8A5588.JPG', 'EZ8A5593.JPG', 'EZ8A5594.JPG', 'EZ8A5602.JPG', 'EZ8A5603.JPG',
        'EZ8A5612.JPG', 'EZ8A5613.JPG', 'EZ8A5616.JPG', 'EZ8A5618.JPG', 'EZ8A5619.JPG',
        'EZ8A5620.JPG', 'EZ8A5621.JPG', 'EZ8A5622.JPG', 'EZ8A5623.JPG', 'EZ8A5624.JPG',
        'EZ8A5625.JPG', 'EZ8A5626.JPG', 'EZ8A5627.JPG', 'EZ8A5628.JPG', 'EZ8A5629.JPG',
        'EZ8A5630.JPG', 'EZ8A5633.JPG', 'EZ8A5634.JPG', 'EZ8A5637.JPG', 'EZ8A5638.JPG',
        'EZ8A5640.JPG', 'EZ8A5642.JPG', 'EZ8A5643.JPG', 'EZ8A5644.JPG', 'EZ8A5645.JPG',
        'EZ8A5647.JPG', 'EZ8A5648.JPG', 'EZ8A5649.JPG', 'EZ8A5650.JPG', 'EZ8A5651.JPG',
        'EZ8A5652.JPG', 'EZ8A5654.JPG', 'EZ8A5655.JPG', 'EZ8A5656.JPG', 'EZ8A5657.JPG',
        'EZ8A5658.JPG', 'EZ8A5659.JPG', 'EZ8A5660.JPG', 'EZ8A5661.JPG', 'EZ8A5662.JPG',
        'EZ8A5663.JPG', 'EZ8A5664.JPG', 'EZ8A5665.JPG', 'EZ8A5666.JPG', 'EZ8A5667.JPG',
        'EZ8A5668.JPG', 'EZ8A5669.JPG', 'EZ8A5670.JPG', 'EZ8A5671.JPG', 'EZ8A5672.JPG',
        'EZ8A5673.JPG', 'EZ8A5674.JPG', 'EZ8A5675.JPG', 'EZ8A5676.JPG', 'EZ8A5677.JPG',
        'EZ8A5678.JPG', 'EZ8A5679.JPG', 'EZ8A5680.JPG', 'EZ8A5681.JPG', 'EZ8A5683.JPG',
        'EZ8A5685.JPG', 'EZ8A5686.JPG', 'EZ8A5687.JPG', 'EZ8A5688.JPG', 'EZ8A5689.JPG',
        'EZ8A5690.JPG', 'EZ8A5691.JPG', 'EZ8A5695.JPG', 'EZ8A5696.JPG', 'EZ8A5699.JPG',
        'EZ8A5707.JPG', 'EZ8A5709.JPG', 'EZ8A5710.JPG', 'EZ8A5713.JPG', 'EZ8A5717.JPG',
        'EZ8A5718.JPG', 'EZ8A5720.JPG', 'EZ8A5723.JPG', 'EZ8A5725.JPG', 'EZ8A5729.JPG',
        'EZ8A5731.JPG', 'EZ8A5733.JPG', 'EZ8A5735.JPG', 'EZ8A5736.JPG', 'EZ8A5737.JPG',
        'EZ8A5739.JPG', 'EZ8A5740.JPG', 'EZ8A5741.JPG', 'EZ8A5742.JPG', 'EZ8A5743.JPG',
        'EZ8A5745.JPG', 'EZ8A5747.JPG', 'EZ8A5748.JPG', 'EZ8A5750.JPG', 'EZ8A5751.JPG',
        'EZ8A5753.JPG', 'EZ8A5756.JPG', 'EZ8A5759.JPG', 'EZ8A5763.JPG', 'EZ8A5765.JPG',
        'EZ8A5768.JPG', 'EZ8A5772.JPG', 'EZ8A5775.JPG', 'EZ8A5776.JPG', 'EZ8A5779.JPG',
        'EZ8A5780.JPG', 'EZ8A5783.JPG', 'EZ8A5785.JPG', 'EZ8A5787.JPG', 'EZ8A5788.JPG',
        'EZ8A5789.JPG', 'EZ8A5791.JPG', 'EZ8A5793.JPG', 'EZ8A5796.JPG', 'EZ8A5798.JPG',
        'EZ8A5799.JPG', 'EZ8A5800.JPG', 'EZ8A5803.JPG', 'EZ8A5805.JPG', 'EZ8A5809.JPG',
        'EZ8A5811.JPG', 'EZ8A5813.JPG', 'EZ8A5816.JPG', 'EZ8A5818.JPG', 'EZ8A5820.JPG',
        'EZ8A5843.JPG', 'EZ8A5845.JPG', 'EZ8A5848.JPG', 'EZ8A5853.JPG', 'EZ8A5854.JPG',
        'EZ8A5855.JPG', 'EZ8A5856.JPG', 'EZ8A5857.JPG', 'EZ8A5858.JPG', 'EZ8A5860.JPG',
        'EZ8A5861.JPG', 'EZ8A5863.JPG', 'EZ8A5864.JPG', 'EZ8A5865.JPG', 'EZ8A5867.JPG',
        'EZ8A5869.JPG', 'EZ8A5870.JPG', 'EZ8A5871.JPG', 'EZ8A5872.JPG', 'EZ8A5873.JPG',
        'EZ8A5874.JPG', 'EZ8A5879.JPG', 'EZ8A5882.JPG', 'EZ8A5883.JPG', 'EZ8A5886.JPG',
        'EZ8A5888.JPG', 'EZ8A5889.JPG', 'EZ8A5890.JPG', 'EZ8A5891.JPG', 'EZ8A5892.JPG',
        'EZ8A5893.JPG', 'EZ8A5894.JPG', 'EZ8A5895.JPG', 'EZ8A5897.JPG', 'EZ8A5898.JPG',
        'EZ8A5899.JPG', 'EZ8A5900.JPG', 'EZ8A5901.JPG', 'EZ8A5902.JPG', 'EZ8A5903.JPG',
        'EZ8A5906.JPG', 'EZ8A5907.JPG', 'EZ8A5909.JPG', 'EZ8A5910.JPG', 'EZ8A5911.JPG',
        'EZ8A5912.JPG', 'EZ8A5915.JPG', 'EZ8A5916.JPG', 'EZ8A5918.JPG', 'EZ8A5919.JPG',
        'EZ8A5920.JPG', 'EZ8A5921.JPG', 'EZ8A5922.JPG', 'EZ8A5929.JPG', 'EZ8A5931.JPG',
        'EZ8A5933.JPG', 'EZ8A5934.JPG', 'EZ8A5935.JPG', 'EZ8A5937.JPG', 'EZ8A5938.JPG',
        'EZ8A5939.JPG', 'EZ8A5940.JPG', 'EZ8A5941.JPG', 'EZ8A5942.JPG', 'EZ8A5943.JPG',
        'EZ8A5944.JPG', 'EZ8A5945.JPG', 'EZ8A5946.JPG', 'EZ8A5947.JPG', 'EZ8A5948.JPG',
        'EZ8A5949.JPG', 'EZ8A5951.JPG', 'EZ8A5952.JPG', 'EZ8A5953.JPG', 'EZ8A5955.JPG',
        'EZ8A5956.JPG', 'EZ8A5957.JPG', 'EZ8A5958.JPG', 'EZ8A5959.JPG', 'EZ8A5960.JPG',
        'EZ8A5961.JPG', 'EZ8A5964.JPG', 'EZ8A5965.JPG', 'EZ8A5966.JPG', 'EZ8A5968.JPG',
        'EZ8A5973.JPG', 'EZ8A5974.JPG', 'EZ8A5975.JPG', 'EZ8A5981.JPG', 'EZ8A5986.JPG',
        'EZ8A5989.JPG', 'EZ8A5993.JPG', 'EZ8A5996.JPG', 'EZ8A5998.JPG', 'EZ8A6000.JPG',
        'EZ8A6002.JPG', 'EZ8A6003.JPG', 'EZ8A6007.JPG', 'EZ8A6008.JPG', 'EZ8A6011.JPG',
        'EZ8A6012.JPG', 'EZ8A6014.JPG', 'EZ8A6015.JPG', 'EZ8A6017.JPG', 'EZ8A6019.JPG',
        'EZ8A6020.JPG', 'EZ8A6023.JPG', 'EZ8A6024.JPG', 'EZ8A6026.JPG', 'EZ8A6028.JPG',
        'EZ8A6030.JPG', 'EZ8A6032.JPG', 'EZ8A6037.JPG', 'EZ8A6038.JPG', 'EZ8A6040.JPG',
        'EZ8A6041.JPG', 'EZ8A6043.JPG', 'EZ8A6044.JPG', 'EZ8A6047.JPG', 'EZ8A6049.JPG',
        'EZ8A6052.JPG', 'EZ8A6053.JPG', 'EZ8A6056.JPG', 'EZ8A6057.JPG', 'EZ8A6058.JPG',
        'EZ8A6060.JPG', 'EZ8A6061.JPG', 'EZ8A6063.JPG', 'EZ8A6065.JPG', 'EZ8A6069.JPG',
        'EZ8A6072.JPG', 'EZ8A6073.JPG', 'EZ8A6076.JPG', 'EZ8A6077.JPG', 'EZ8A6079.JPG',
        'EZ8A6083.JPG', 'EZ8A6085.JPG', 'EZ8A6088.JPG', 'EZ8A6094.JPG', 'EZ8A6096.JPG',
        'EZ8A6098.JPG', 'EZ8A6104.JPG', 'EZ8A6108.JPG', 'EZ8A6114.JPG', 'EZ8A6115.JPG',
        'EZ8A6118.JPG', 'EZ8A6120.JPG', 'EZ8A6121.JPG', 'EZ8A6122.JPG', 'EZ8A6123.JPG',
        'EZ8A6125.JPG', 'EZ8A6128.JPG', 'EZ8A6137.JPG', 'EZ8A6141.JPG', 'EZ8A6142.JPG',
        'EZ8A6145.JPG', 'EZ8A6147.JPG', 'EZ8A6151.JPG', 'EZ8A6154.JPG', 'EZ8A6159.JPG',
        'EZ8A6164.JPG', 'EZ8A6170.JPG', 'EZ8A6172.JPG', 'EZ8A6173.JPG', 'EZ8A6174.JPG',
        'EZ8A6175.JPG', 'EZ8A6177.JPG', 'EZ8A6178.JPG', 'EZ8A6179.JPG', 'EZ8A6181.JPG',
        'EZ8A6185.JPG', 'EZ8A6186.JPG', 'EZ8A6187.JPG', 'EZ8A6188.JPG', 'EZ8A6189.JPG',
        'EZ8A6190.JPG', 'EZ8A6191.JPG', 'EZ8A6192.JPG', 'EZ8A6193.JPG', 'EZ8A6194.JPG',
        'EZ8A6195.JPG', 'EZ8A6196.JPG', 'EZ8A6197.JPG', 'EZ8A6198.JPG', 'EZ8A6199.JPG',
        'EZ8A6200.JPG', 'EZ8A6202.JPG', 'EZ8A6205.JPG', 'EZ8A6206.JPG', 'EZ8A6207.JPG',
        'EZ8A6211.JPG', 'EZ8A6212.JPG', 'EZ8A6213.JPG', 'EZ8A6214.JPG', 'EZ8A6216.JPG',
        'EZ8A6217.JPG', 'EZ8A6218.JPG', 'EZ8A6219.JPG', 'EZ8A6220.JPG', 'EZ8A6222.JPG',
        'EZ8A6224.JPG', 'EZ8A6225.JPG', 'EZ8A6227.JPG', 'EZ8A6229.JPG', 'EZ8A6230.JPG',
        'EZ8A6232.JPG', 'EZ8A6233.JPG', 'EZ8A6235.JPG', 'EZ8A6236.JPG', 'EZ8A6241.JPG'
      ];
      
      return event2Photos.map((filename, index) => {
        // Use very consistent aspect ratios for optimal packing
        return {
          src: `/event-pics/event2/${filename}`,
          width: 4,
          height: 3
        };
      });
    } else {
      const event1Photos = [
        'PHOTO-2022-11-23-15-45-07.jpg', 'PHOTO-2022-11-23-15-45-07 3.jpg',
        'PHOTO-2022-12-20-23-42-39.jpg', 'PHOTO-2022-12-20-23-42-40.jpg',
        'PHOTO-2022-12-20-23-42-40 2.jpg', 'PHOTO-2022-12-20-23-42-40 3.jpg',
        'PHOTO-2022-12-20-23-42-40 4.jpg', 'PHOTO-2022-12-20-23-42-40 5.jpg',
        'PHOTO-2022-12-20-23-42-40 6.jpg', 'PHOTO-2022-12-20-23-42-40 7.jpg',
        'PHOTO-2022-12-20-23-42-40 8.jpg', 'PHOTO-2022-12-20-23-42-40 9.jpg',
        'PHOTO-2022-12-20-23-42-40 10.jpg'
      ];
      
      return event1Photos.map((filename, index) => {
        // Use varied aspect ratios that match typical photo dimensions
        const aspectRatios = [
          { width: 4, height: 3 },   // Standard landscape
          { width: 3, height: 4 },   // Portrait
          { width: 4, height: 3 },   // Standard landscape
          { width: 4, height: 3 },   // Standard landscape
          { width: 3, height: 4 },   // Portrait
          { width: 4, height: 3 },   // Standard landscape
          { width: 4, height: 3 },   // Standard landscape
          { width: 3, height: 4 },   // Portrait
          { width: 4, height: 3 },   // Standard landscape
          { width: 4, height: 3 },   // Standard landscape
          { width: 16, height: 9 },  // Wide landscape (might be the problematic one)
          { width: 3, height: 4 },   // Portrait
          { width: 4, height: 3 }    // Standard landscape
        ];
        
        return {
          src: `/event-pics/event1/${filename}`,
          ...aspectRatios[index]
        };
      });
    }
  };

  const eventData = {
    '2': {
      id: 2,
      title: "Amegnona Gathering 2025",
      description: "Our latest gathering celebrating unity, brotherhood, and the continued strength of our community bonds. A memorable event showcasing our growth and solidarity, bringing together members from across the community to celebrate our shared heritage and future.",
      photos: generateEventPhotos('2')
    },
    '1': {
      id: 1,
      title: "Community Gathering 2022",
      description: "A celebration bringing members together in solidarity and brotherhood, sharing moments of joy and community spirit. This event highlighted the values that make our club a cornerstone of the community - unity, support, and cultural pride.",
      photos: generateEventPhotos('1')
    }
  };

  const event = eventData[eventId];

  const openLightbox = useCallback((event, { photo, index }) => {
    setLightboxIndex(index);
  }, []);

  const lightboxSlides = event?.photos?.map(photo => ({
    src: photo.src,
  })) || [];

  if (!event) {
    return (
      <div className="event-detail">
        <div className="container">
          <div className="event-not-found">
            <h1>Event Not Found</h1>
            <p>The event you're looking for doesn't exist.</p>
            <Link to="/gallery" className="back-link">← Back to Events and Photos</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="event-detail">
      <div className="container">
        <div className="event-detail-header">
          <Link to="/gallery" className="back-link">← Back to Events and Photos</Link>
          <div className="event-info">
            <h1>{event.title}</h1>
            <p className="event-description">{event.description}</p>
          </div>
        </div>

        <div className="event-photos">
          <h2>Photos from this Event ({event.photos.length} photos)</h2>
          <div className="photo-gallery-container">
            <PhotoGallery
              photos={event.photos}
              onClick={openLightbox}
              direction={"column"}
              margin={3}
              targetRowHeight={200}
            />
          </div>
        </div>
      </div>

      <Lightbox
        open={lightboxIndex >= 0}
        index={lightboxIndex}
        close={() => setLightboxIndex(-1)}
        slides={lightboxSlides}
        plugins={[Fullscreen, Slideshow, Thumbnails, Zoom]}
        zoom={{
          maxZoomPixelRatio: 3,
          zoomInMultiplier: 2,
          doubleTapDelay: 300,
        }}
        thumbnails={{
          position: "bottom",
          width: 120,
          height: 80,
          border: 0,
          borderRadius: 4,
        }}
        slideshow={{
          autoPlay: false,
          delay: 3000,
        }}
      />
    </div>
  );
};

export default EventDetail;